import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';

import Grid, { GridSpacing } from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import LoadingButton from '@mui/lab/LoadingButton';

import { SIGC_CMP_GROUP_SET } from '../../../function/GroupDataModel';
import RawWaveformComparisonConanChart, { GraphDispSetting } from './RawWaveformComparisonConanairChart';
import RawWaveformComparisonSelectItem from './RawWaveformComparisonConanairSelectItem';
import RawWaveformComparisonChartSetting from './RawWaveformComparisonConanairChartSetting';
import RawWaveformComparisonButtonList from './RawWaveformComparisonConanairButtonList';
import {
  MeasureInfoType,
  GetMeasureInfoType,
  SelectDataType,
  GetLatesTime,
  GetDataTimeList,
  CreateSelectData,
  CreateDefalutSelectDataType,
} from './RawWaveformComparisonConanair';
import SearchIcon from '@material-ui/icons/Search';
import { useTranslation } from 'react-i18next';
import Box from '@material-ui/core/Box';

import { RawWaveformComparisonConanairStyle } from './RawWaveformComparisonConanairStyle';
import { SpeedKind } from '../../../Constant';
import { GetKindNoNameSetType, KIND_NO_NAME_SET } from '../MeasureSetting/CollectSetting/CollectSettingDefine';
import { ComboBoxItemType } from '../../atoms/ComboBox/ItemComboBox';

type RawWaveformComparisonConanairPageProps = {
  location: { state: SIGC_CMP_GROUP_SET };
};

const RawWaveformComparisonConanairPage: React.FC<RawWaveformComparisonConanairPageProps> = (props) => {
  const { t } = useTranslation();
  const pageStyle = RawWaveformComparisonConanairStyle();

  const [loading, setLoading] = React.useState<boolean>(false);
  const [chartUpdate, setChartUpdate] = React.useState<string>('');
  const [measureInfo, setMeasereInfo] = React.useState<MeasureInfoType[]>([]);
  const [isLineShows, setIsLineShow] = React.useState<boolean[]>([true, true]);
  const [selectData1, setSelectData1] = React.useState<SelectDataType>(CreateDefalutSelectDataType());
  const [selectData2, setSelectData2] = React.useState<SelectDataType>(CreateDefalutSelectDataType());
  const [conanRawWaveComboList, setConanRawWaveComboList] = useState<ComboBoxItemType[]>([]);
  const [graphDispSetting, SetGraphDispSetting] = React.useState<GraphDispSetting>({
    xMin: 0,
    xMax: 100,
    y1Min: -0.02,
    y1Max: 0.02,
    y2Min: -0.02,
    y2Max: 0.02,
    isPileup: false,
    isDCRemoval: true,
  });
  const isAutoRangeRef = React.useRef<boolean>(true);

  useEffect(() => {
    let mesRet: MeasureInfoType[] = [];
    let kindNoNameSet: KIND_NO_NAME_SET[] = [];
    let conanRawWaveTypList: ComboBoxItemType[] = [];

    setLoading(true);
    GetMeasureInfoType()
      .then((res) => {
        mesRet = res
        //console.debug(['★mesRet1', mesRet]);
        //CollectSettingDefine.tsからKIND_NO_NAME_SETをとってくる
        return GetKindNoNameSetType();
      }).then((res) => {
        kindNoNameSet = res;
        conanRawWaveTypList.push({ index: -1, name: "" });
        //生波形(コナン)で必要ない項目は省く
        kindNoNameSet.forEach((r) => {
          if (r.SPEED === SpeedKind.SPEED_CONAN && r.FFT_INVALID === 1) {
            conanRawWaveTypList.push({ index: r.NAME_NO, name: r.MES_NAME });
          }
        })

        //コレクションを使ってComboBoxにする
        setConanRawWaveComboList(conanRawWaveTypList);
        //生波形画面では不要な項目を排除
        //mesRet = mesRet.filter((r) => r.FftInvalid === 0);
        mesRet = mesRet.filter((r) => r.Speed === SpeedKind.SPEED_CONAN);
        //console.debug(['★mesRet2', mesRet]);

        for (var i in mesRet) {
          mesRet[i].id = Number(i + 1);
        }
        var s1: SelectDataType = CreateDefalutSelectDataType();
        var s2: SelectDataType = CreateDefalutSelectDataType();

        if (props.location.state !== null) {
          var gp = props.location.state;
          var dt1 = mesRet.find((item) => item.PlcNo === gp.PLC_NO1);
          var dt2 = mesRet.find((item) => item.PlcNo === gp.PLC_NO2);
          //console.debug(['★dt1,dt2,gp', dt1, dt2, gp]);

          if (gp.Time_No1 !== undefined) {
            console.debug(['reseve SIGC_CMP_GROUP_SET', gp, gp.Time_No1]);
            s1 = CreateSelectData(mesRet, 1, dt1, gp);
            s1.selectDate = gp.Time_No1 === '' ? new Date() : dayjs(gp.Time_No1).toDate();
            s1.selectTime = '';

            s2 = CreateSelectData(mesRet, 2, dt2, gp);
            s2.selectDate = gp.Time_No2 === '' ? new Date() : dayjs(gp.Time_No2).toDate();
            s2.selectTime = '';

            var c = GetDataTimeList(
              Number(dt1?.PlcNo),
              Number(dt1?.AiCard),
              Number(dt1?.AiCh),
              dayjs(s1.selectDate).format('YYYY-MM-DD'),
              s1.mesid,
            );
            var d = GetDataTimeList(
              Number(dt2?.PlcNo),
              Number(dt2?.AiCard),
              Number(dt2?.AiCh),
              dayjs(s2.selectDate).format('YYYY-MM-DD'),
              s2.mesid,
            );
            Promise.all([c, d]).then((ret) => {
              if (ret) {
                if (ret[0] && ret[0][0]) {
                  s1.selectTime = dayjs(ret[0][0]).format('HH:mm:ss');
                }
                if (ret[1] && ret[1][0]) {
                  s2.selectTime = dayjs(ret[1][0]).format('HH:mm:ss');
                }
              }

              console.debug(['sData1', dt1, s1]);
              console.debug(['sData2', dt2, s2]);
              setSelectData1({ ...s1 });
              setSelectData2({ ...s2 });
              setMeasereInfo(mesRet);
              setChartUpdate('start');
              setLoading(true);
            });
          } else {
            var a = GetLatesTime(gp.SET_NO1, dt1?.PlcNo, dt1?.AiCard, dt1?.AiCh);
            var b = GetLatesTime(gp.SET_NO2, dt2?.PlcNo, dt2?.AiCard, dt2?.AiCh);
            //console.debug(['★GetLatesTime', a, b]);

            Promise.all([a, b]).then((ret) => {
              s1 = CreateSelectData(mesRet, 1, dt1, gp);
              if (dayjs(new Date(ret[0])).format('YYYY-MM-DD') == '1-01-01') {
                s1.selectDate = new Date();
                s1.selectTime = '';
              } else {
                s1.selectDate = new Date(ret[0]);
                s1.selectTime = dayjs(new Date(ret[0])).format('HH:mm:ss');
              }

              s2 = CreateSelectData(mesRet, 2, dt2, gp);
              if (dayjs(new Date(ret[1])).format('YYYY-MM-DD') == '1-01-01') {
                s2.selectDate = new Date();
                s2.selectTime = '';
              } else {
                s2.selectDate = new Date(ret[1]);
                s2.selectTime = dayjs(new Date(ret[1])).format('HH:mm:ss');
              }

              console.debug(['sData1', dt1, s1]);
              console.debug(['sData2', dt2, s2]);

              setSelectData1({ ...s1 });
              setSelectData2({ ...s2 });
              setMeasereInfo(mesRet);
              setChartUpdate('start');
              setLoading(true);
            });
          }
        } else {
          setSelectData1({ ...s1 });
          setSelectData2({ ...s2 });
          setMeasereInfo(mesRet);
        }
      })
      .catch((r) => { });
  }, []);

  const handleLoadingStateChange = (value: boolean): void => setLoading(value);

  const handleisShowSelectChange1 = (value: SelectDataType) => {
    setIsLineShow([value.isShow, isLineShows[1]]);
    setSelectData1({ ...value });
  };
  const handleisShowSelectChange2 = (value: SelectDataType) => {
    setIsLineShow([isLineShows[0], value.isShow]);
    setSelectData2({ ...value });
  };

  const handleonSelectData1Change = (value: SelectDataType) => {
    setSelectData1({ ...value });
  };
  const handleonSelectData2Change = (value: SelectDataType) => {
    setSelectData2({ ...value });
  };
  const handleChartUpdate = () => {
    setChartUpdate(dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'));
  };

  const handleGraphSettingChange = (data: GraphDispSetting) => {
    SetGraphDispSetting({ ...data });
  };
  const handleYMinMaxChange = (min1: number, max1: number, min2: number, max2: number) => {
    SetGraphDispSetting({ ...graphDispSetting, y1Min: min1, y1Max: max1, y2Min: min2, y2Max: max2 });
  };

  const handleLoading = (isFlg: boolean) => {
    setLoading(isFlg);
  };
  const handoleAutoRangeSet = (data: boolean) => {
    isAutoRangeRef.current = data;
  };

  return (
    <div>
      <Box display="flex" justifyContent="flex-start" alignItems="flex-end">
        <div style={{ width: 10 }}></div>{' '}
        <div style={{ width: 300 }}>
          <Paper>
            <RawWaveformComparisonSelectItem
              itemName={t('RawWaveformComparisonConanairPage.計測データ１', '計測データ１')}
              onChangeSelectDataEvent={handleonSelectData1Change}
              onChnageIsShowSelect={handleisShowSelectChange1}
              itemColor="red"
              selectData={selectData1}
              mesInfoList={measureInfo}
              isBlankSelect={false}
              onAutoRangeSet={handoleAutoRangeSet}
              rawWaveCombobox={conanRawWaveComboList}
            />
          </Paper>
        </div>{' '}
        <div style={{ width: 10 }}></div>
        <div style={{ width: 300 }}>
          <Paper>
            <RawWaveformComparisonSelectItem
              itemName={t('RawWaveformComparisonConanairPage.計測データ２', '計測データ２')}
              onChangeSelectDataEvent={handleonSelectData2Change}
              onChnageIsShowSelect={handleisShowSelectChange2}
              itemColor="blue"
              selectData={selectData2}
              mesInfoList={measureInfo}
              isBlankSelect={true}
              onAutoRangeSet={handoleAutoRangeSet}
              rawWaveCombobox={conanRawWaveComboList}
            />
          </Paper>
        </div>
        <div style={{ width: 10 }}></div>
        <div style={{ width: 100 }}>
          <LoadingButton
            style={{ width: '100px' }}
            loading={loading}
            loadingPosition="start"
            variant="contained"
            startIcon={<SearchIcon />}
            onClick={handleChartUpdate}
          >
            {t('RawWaveformComparisonConanairPage.表示', '表示　')}
          </LoadingButton>
        </div>
        <div style={{ width: 10 }}></div>
        <RawWaveformComparisonChartSetting settingData={graphDispSetting} onChange={handleGraphSettingChange} />
      </Box>
      <Grid container justify="flex-start" spacing={1} direction="row" alignItems="flex-end" style={{ margin: 0 }}>
        <Grid item xs={12}>
          <RawWaveformComparisonConanChart
            onChagneYMinMax={handleYMinMaxChange}
            chartContainerStyle={pageStyle.responsiveContainer}
            graphDispSetting={graphDispSetting}
            line1={selectData1}
            line2={selectData2}
            mesList={measureInfo}
            update={chartUpdate}
            isLineShows={isLineShows}
            onLoading={handleLoading}
            isAutoRangeRef={isAutoRangeRef.current}
            onAutoRangeSet={handoleAutoRangeSet}
          />
        </Grid>
        <Grid item xs={12}>
          <RawWaveformComparisonButtonList
            measureInfo={measureInfo}
            selectDatas={[selectData1, selectData2]}
          ></RawWaveformComparisonButtonList>
        </Grid>
      </Grid>
    </div>
  );
};

export default RawWaveformComparisonConanairPage;
